export default {
  data () {
    return {
      showRejectReasonModalFlag: false,
      transactionIdToReject: false,
      isSettingReviewStatus: false
    }
  },
  computed: {
    // Susceptible de moverse a mixin
    reviewStatus () {
      return this.transaction && this.transaction.reviewStatus
        ? this.transaction.reviewStatus.code
        : false
    },
    isBudgetOwner () {
      return this.transaction && this.transaction.budget
        ? this.transaction.budget.imOwner
        : false
    },
    transactionOwner () {
      return this.transaction && this.transaction.card
        ? this.transaction.card.user
        : false
    },

    reviewStatusTypes () {
      return this.$store.getters['ConfigStore/privateConfig']
        ? this.$store.getters['ConfigStore/privateConfig']
          .transaction_review_statuses
        : false
    }
  },
  methods: {
    _canMoveToNextReviewStatus (currentStatus, nextStatus) {
      const reviewStatusType = this.reviewStatusTypes.find(
        el => el.code === currentStatus
      )
      if (reviewStatusType) {
        const { allowedTransitions } = reviewStatusType
        return allowedTransitions.includes(nextStatus)
      }
      return false
    },
    async setReviewStatusAsCancelled (rejectReason) {
      if (!this.transactionIdToReject || this.isSettingReviewStatus) return
      this.isSettingReviewStatus = true
      const cancelledReviewStatusType = this.reviewStatusTypes.find(
        el => el.code === 'CANCELLED'
      )
      if (cancelledReviewStatusType) {
        const reviewInformation = {
          reviewStatus: { id: cancelledReviewStatusType.id },
          reviewRejectedReason: rejectReason
        }
        await this.$store.dispatch(
          'TransactionsStore/setTransactionReviewStatus',
          {
            transactionId: this.transactionIdToReject,
            reviewStatus: reviewInformation
          }
        )
        this.showRejectReasonModalFlag = false
      }
      this.isSettingReviewStatus = false
      this.closeModals()
    },
    async setReviewStatus (nextStatus) {
      if (this.isSettingReviewStatus) return
      this.isSettingReviewStatus = true

      if (this._canMoveToNextReviewStatus(this.reviewStatus, nextStatus)) {
        const nextStatusType = this.reviewStatusTypes.find(
          el => el.code === nextStatus
        )
        let reviewData = {
          reviewStatus: { id: nextStatusType.id }
        }

        await this.$store.dispatch(
          'TransactionsStore/setTransactionReviewStatus',
          { transactionId: this.transactionId, reviewStatus: reviewData }
        )
      } else {
        await this.$store.dispatch(
          'SnackBars/addError',
          this.$i18n.t(
            'transactions_funnel_update_status_transition_not_allowed'
          )
        )
      }
      this.isSettingReviewStatus = false
      this.closeAllModals()
    },
    emitReviewStatusChanged () {
      this.$emit('reviewStatusChanged')
    }
  }
}
